import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../contexts/analytics/hooks";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { useSnackbar } from "../contexts/SnackbarContext";
import { backendService } from "../services/backend.service";
import { useErrorSnackbar } from "./useErrorSnackbar";

export const useSyncPtos = () => {
	const { chosenDepartment } = useChosenDepartment();
	const showErrorSnackbar = useErrorSnackbar();
	const { showSnackbar } = useSnackbar();
	const { track } = useAnalytics();
	const { t } = useTranslation();

	return useMutation({
		mutationFn: async () => {
			if (!chosenDepartment?.department_id) return;
			const response = await backendService.syncPtos({ departmentId: chosenDepartment.department_id });
			return response.data;
		},
		onSuccess: (data) => {
			if (!data) return;
			const messageKey = data.task_names.length > 0 ? "pto.sync.scheduled" : "pto.sync.already.running";
			showSnackbar(t(messageKey), "success");
			track("Integrations - PTO sync scheduled", {
				bumped_count: data.task_names.length,
				already_running_count: data.already_running_task_names.length,
				bumped_tasks: data.task_names.join(","),
				already_running_tasks: data.already_running_task_names.join(","),
			});
		},
		onError: (error) => showErrorSnackbar(t("pto.sync.failed"), { action: "external_pto_sync" }, error),
	});
};
